import React from 'react';
import { CSSProperties } from 'styled-components';
import cx from 'classnames';
import styles from './index.scss';
import { useTranslation } from '@jupiter-app/plugin-i18n';
interface TagLimitLineProps {
  wrapClassNames?: string;
  itemClassNames?: string;
  style?: CSSProperties;
  tagList?: string[];
}

enum TagType {
  Tag_Feature = 'academy_knowledge_tab_course_tag_featured', // Feature
  Tag_Beginner = 'academy_knowledge_tab_course_tag_begin', // Beginner
  Tag_Growing = 'academy_knowledge_tab_course_tag_grow', // Growing
  Tag_Specialist = 'academy_knowledge_tab_course_tag_mature', // Specialist
  Tag_Other = 'academy_knowledge_tab_course_tag_other', // Other
}

const tagStyle = {
  [TagType.Tag_Feature]: {
    name: TagType.Tag_Feature,
    color: '#FBA642',
    bg: '#FFEEDA',
  },
  [TagType.Tag_Beginner]: {
    name: TagType.Tag_Beginner,
    color: '#40D9B5',
    bg: '#D4FFF5',
  },
  [TagType.Tag_Growing]: {
    name: TagType.Tag_Growing,
    color: '#40D9B5',
    bg: '#D4FFF5',
  },
  [TagType.Tag_Specialist]: {
    name: TagType.Tag_Specialist,
    color: '#40D9B5',
    bg: '#D4FFF5',
  },
  [TagType.Tag_Other]: {
    name: TagType.Tag_Other,
    color: '#40D9B5',
    bg: '#D4FFF5',
  },
};

function getTagStyle(tagName) {
  const res = {
    name: tagName,
  };
  console.log(tagName === TagType.Tag_Feature, 'true');
  switch (tagName) {
    case [TagType.Tag_Beginner]:
    case [TagType.Tag_Growing]:
    case [TagType.Tag_Other]:
    case [TagType.Tag_Specialist]:
    default:
      return Object.assign(res, {
        color: '#40D9B5',
        bg: '#D4FFF5',
      });
    case [TagType.Tag_Feature]:
      return Object.assign(res, {
        color: '#FBA642',
        bg: '#FFEEDA',
      });
  }
}

const TagLimitLine: React.FC<TagLimitLineProps> = props => {
  const { tagList } = props;
  const { t } = useTranslation();

  return (
    <ul className={cx(styles.tagList, styles.clearfix, props.wrapClassNames)}>
      {tagList?.map((tag, idx) => {
        return (
          <li
            className={cx(styles.tagItem, props.itemClassNames)}
            key={idx}
            style={{
              color: tagStyle[tag].color,
              backgroundColor: tagStyle[tag].bg,
            }}>
            {t(tag)}
          </li>
        );
      })}
    </ul>
  );
};

export default TagLimitLine;
